module.exports = __webpack_public_path__ + "media/images/athletes/3592-5c2861ccaa6e88ba177b9028805100bc.png";